import { Tooltip } from "@/components/ui/tooltip";
import { Box, Card, SimpleGrid, Skeleton, Stat, Text } from "@chakra-ui/react";
import { Info, UserPlus, Users } from "lucide-react";
import { useFetchSubscriptionMetrics } from "../hooks/useFetchSubscriptionMetrics";

export default function SubscriptionMetricsCards() {
  const { metrics, isLoading } = useFetchSubscriptionMetrics();
  const totalActive = metrics?.totalActive;
  const totalGuests = metrics?.totalGuests;
  const maxGuests = metrics?.maxGuests;

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
      <Card.Root
        size="sm"
        variant="elevated"
        bg="palomma.500"
        color="white"
        borderRadius="lg"
        boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
      >
        <Card.Body p={3}>
          <Box display="flex" alignItems="center" gap={3}>
            <Box bg="whiteAlpha.200" p={2} borderRadius="full" flexShrink={0}>
              <Users size={18} color="white" />
            </Box>
            <Stat.Root flex={1} minW={0}>
              <Box display="flex" alignItems="baseline" gap={2}>
                {isLoading ? (
                  <Skeleton height="28px" width="48px" bg="whiteAlpha.300" />
                ) : (
                  <Stat.ValueText
                    fontSize="2xl"
                    fontWeight="bold"
                    letterSpacing="tight"
                  >
                    {totalActive ?? "-"}
                  </Stat.ValueText>
                )}
                <Text fontWeight="medium" fontSize="sm" color="whiteAlpha.800">
                  Activos
                </Text>
              </Box>
              <Stat.HelpText color="whiteAlpha.800" mt={0} fontSize="xs">
                Inquilinos suscritos
              </Stat.HelpText>
            </Stat.Root>
          </Box>
        </Card.Body>
      </Card.Root>

      <Card.Root
        size="sm"
        variant="elevated"
        bg="white"
        borderRadius="lg"
        boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
      >
        <Card.Body p={3}>
          <Box display="flex" alignItems="center" gap={3}>
            <Box bg="gray.100" p={2} borderRadius="full" flexShrink={0}>
              <UserPlus size={18} color="#a0aec0" />
            </Box>
            <Stat.Root flex={1} minW={0}>
              <Box display="flex" alignItems="baseline" gap={2}>
                {isLoading ? (
                  <Skeleton height="28px" width="64px" />
                ) : (
                  <Stat.ValueText
                    fontSize="2xl"
                    fontWeight="bold"
                    color="gray.800"
                    letterSpacing="tight"
                  >
                    {totalGuests != undefined && maxGuests != undefined
                      ? `${totalGuests}/${maxGuests}`
                      : "-"}
                  </Stat.ValueText>
                )}
                <Box display="flex" alignItems="center" gap={1}>
                  <Text fontWeight="medium" fontSize="sm" color="gray.500">
                    Invitados
                  </Text>
                  <Tooltip
                    content="Contáctanos para aumentar el cupo de invitados"
                    showArrow
                    positioning={{ placement: "top" }}
                    contentProps={{
                      bg: "gray.800",
                      color: "white",
                      fontSize: "sm",
                      fontWeight: "medium",
                      px: 3,
                      py: 2,
                      borderRadius: "md",
                      maxW: "240px",
                      textAlign: "center",
                      boxShadow: "lg",
                    }}
                  >
                    <Box
                      as="span"
                      display="inline-flex"
                      alignItems="center"
                      justifyContent="center"
                      cursor="help"
                      borderRadius="full"
                      color="gray.400"
                      transition="all 0.15s ease"
                      _hover={{ color: "gray.600" }}
                    >
                      <Info size={14} />
                    </Box>
                  </Tooltip>
                </Box>
              </Box>
              <Stat.HelpText color="gray.500" mt={0} fontSize="xs">
                Invita a propietarios y colaboradores
              </Stat.HelpText>
            </Stat.Root>
          </Box>
        </Card.Body>
      </Card.Root>
    </SimpleGrid>
  );
}
